export default function (data) {
  var self = this;
  self.bulk_update_sales = ko.observableArray();
  self.paginator = ko.observable();
  self.isAddBulkButton = ko.observable(true);
  self.isUpdateBulkButton = ko.observable(false);
  self.selectedBulkId = ko.observable();
  self.$el = $('#bulk_price_updates');

  self.selectedCourse = ko.observable({
    sale_name: ko.observable(),
    sale_price: ko.observable(),
    sale_type: ko.observable(),
    sale_start_date: ko.observable(),
    sale_end_date: ko.observable(),
  });

  self.initUI = function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.bulkUpdateSaleListing);
  };

  self.bulkUpdateSaleListing = function (params) {
    Kadenze.UIUtil.showLoadingIndicator(self.$el);
    //load the entries info from the server
    var url = 'bulk_price';

    $.ajax({
      type: 'GET',
      url: url,
      data: params,
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      }
    }).success(function (data) {
      self.bindData(data);
    }).error(function (data) {
      console.log(data);
    }).always(function (data) {
      Kadenze.UIUtil.hideLoadingIndicator(self.$el);
      Kadenze.PaginationBinding.applyBindingsWithTextInput(self.bulkUpdateSaleListing);
    });
  };

  self.removeBulkPrice = item => {
    let url = "remove_bulk_price"
    let data = { id: item.id()}
    let request = new Kadenze.AjaxRequest({
      url: url,
      type: 'DELETE',
      data
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: xhr.responseJSON.message });
      self.bulkUpdateSaleListing();
    });

    request.fail(function(xhr) {
      let json = xhr.responseJSON;
        if (json != undefined) {
        new Kadenze.Notice.error({ message: xhr.responseJSON.message });
      }
      else {
        new Kadenze.Notice.error({ message: 'An unexpected error occurred' });
      }
    });
  };

  self.resetSelectedCourse = () => {
    self.selectedCourse().sale_name('');
    self.selectedCourse().sale_type('');
    self.selectedCourse().sale_price('');
    self.selectedCourse().sale_start_date('');
    self.selectedCourse().sale_end_date('');
  };

  self.getSelectedCourse = (item) => {
    self.selectedCourse().sale_name(item.sale_name);
    self.selectedCourse().sale_price(item.sale_price);
    self.selectedCourse().sale_type(item.sale_type);
    self.selectedCourse().sale_start_date(item.sale_start_date);
    self.selectedCourse().sale_end_date(item.sale_end_date);
    self.selectedBulkId(item.id)
  };

  self.addBulkPrice = () => {
    const url = 'add_bulk_price';
    const data = ko.mapping.toJS(self.selectedCourse());

    if (data.sale_start_date && data.sale_start_date.trim() !== '') {
      data.sale_start_date = Kadenze.Util.getMomentDateFromObservable(
        self.selectedCourse().sale_start_date
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    if (data.sale_end_date && data.sale_end_date.trim() !== '') {
      data.sale_end_date = Kadenze.Util.getMomentDateFromObservable(
        self.selectedCourse().sale_end_date
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    Kadenze.UIUtil.makeRequest(
      url,
      'POST',
      data,
      self.$el,
      null,
      (data, textStatus, xhr) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 5000);
        self.resetSelectedCourse();
        self.bulkUpdateSaleListing();
      },

      (xhr, textStatus, errorThrown) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 5000);
      }
    );
  };

  self.editBulkPrice = item => {
    const url = "edit_bulk_price/" + item.id()
    const request = new Kadenze.AjaxRequest({
      url: url,
      type: 'GET'
    });

    request.done(function(data, status, xhr) {
      new Kadenze.Notice.success({ message: xhr.responseJSON.message });
      self.getSelectedCourse( xhr.responseJSON.bulk_price_sale)
      self.isUpdateBulkButton(true)
      self.isAddBulkButton(false)
    });

    request.fail(function(xhr) {
      let json = xhr.responseJSON;
        if (json != undefined) {
        new Kadenze.Notice.error({ message: xhr.responseJSON.message });
      }
      else {
        new Kadenze.Notice.error({ message: 'An unexpected error occurred' });
      }
    });
  };

  self.updateBulkPrice = () => {
    const url = 'update_bulk_price/' + self.selectedBulkId() ;
    const data = ko.mapping.toJS(self.selectedCourse());

    if (data.sale_start_date && data.sale_start_date.trim() !== '') {
      data.sale_start_date = Kadenze.Util.getMomentDateFromObservable(
        self.selectedCourse().sale_start_date
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    if (data.sale_end_date && data.sale_end_date.trim() !== '') {
      data.sale_end_date = Kadenze.Util.getMomentDateFromObservable(
        self.selectedCourse().sale_end_date
      ).utc().format(
        I18n.t('date.formats.js_default_with_zone')
      )
    }

    Kadenze.UIUtil.makeRequest(
      url,
      'PATCH',
      data,
      self.$el,
      null,
      (data, textStatus, xhr) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), data, 5000);
        self.resetSelectedCourse();
        self.bulkUpdateSaleListing();
        self.isUpdateBulkButton(false)
        self.isAddBulkButton(true)
      },
      (xhr, textStatus, errorThrown) => {
        Kadenze.UIUtil.showNotice($('#notice_container'), xhr.responseJSON, 5000);
      }
    );
  };

  self.bindData = function(data) {
    var mapped = ko.mapping.fromJS(data.bulk_update_sales);
    self.bulk_update_sales(mapped());
    self.paginator(data.paginator);
  };

  const __construct = function(that) {
    console.log('constructor called for AdminCourseBulk ViewModel');
    that.bindData(data);
  }(this);
}
